import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-2bdd3984"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "" };
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h1", null, "测试页面", -1));
import { ref } from "vue";
import { mainStore } from "@/store";
/* 获取子组件的引用 */
export default /*#__PURE__*/ _defineComponent({
    __name: 'Test',
    setup(__props) {
        const text_setup_ref = ref();
        const test_name = ref("这是test的初始name");
        const store = mainStore();
        const updateName = (param) => {
            const { name = "" } = param;
            test_name.value = name;
        };
        /* 获取子组件的引用 */
        const getRefValue = () => {
            console.log('接收ref暴漏出来的值', text_setup_ref.value.test_setup_age);
            console.log('接收reactive暴漏出来的值', text_setup_ref.value.test_setup_phone.phone);
        };
        // export default defineComponent({
        //   name: "Test",
        //   components: {
        //     Test2,
        //     Test_setupVue
        //   },
        //   setup() {
        //     const text_setup_ref = ref();
        //     const test_name = ref("这是test的初始name")
        //     const store = mainStore();
        //     const updateName = (param: UpdateName) => {
        //       const { name = "" } = param
        //       test_name.value = name
        //     }
        //     /* 获取子组件的引用 */
        //     const getRefValue = () => {
        //       console.log('接收ref暴漏出来的值', text_setup_ref.value.test_setup_age)
        //     }
        //     return {
        //       store,
        //       batbLogo,
        //       test_name,
        //       updateName,
        //       getRefValue
        //     };
        //   },
        // });
        return (_ctx, _cache) => {
            const _component_Test_setupVue = _resolveComponent("Test_setupVue");
            const _component_el_button = _resolveComponent("el-button");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _hoisted_2,
                _createElementVNode("h2", null, _toDisplayString(_unref(store).content), 1),
                _createVNode(_component_Test_setupVue, {
                    name: test_name.value,
                    onUpdateName: updateName,
                    ref_key: "text_setup_ref",
                    ref: text_setup_ref
                }, null, 8, ["name"]),
                _createVNode(_component_el_button, {
                    type: "",
                    onClick: getRefValue
                }, {
                    default: _withCtx(() => [
                        _createTextVNode("获取子组件test_setup的属性")
                    ]),
                    _: 1
                })
            ]));
        };
    }
});
